import { render, staticRenderFns } from "./AreaNewsList.vue?vue&type=template&id=a1b45a06&scoped=true&"
import script from "./AreaNewsList.vue?vue&type=script&lang=js&"
export * from "./AreaNewsList.vue?vue&type=script&lang=js&"
import style0 from "./AreaNewsList.vue?vue&type=style&index=0&id=a1b45a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b45a06",
  null
  
)

export default component.exports